import React from "react";
import PasswordStrengthBar from "react-password-strength-bar";
import { Input } from "./styledComponents";

export default class InputRPS extends React.PureComponent {
  state = {
    password: "",
  };

  handleOnChange = (event) => {
    const value = event.target.value;
    this.setState({ ...this.state, password: value });
    if (this.props.changeCallback != null) {
      this.props.changeCallback(value);
    }
  };

  render() {
    const { score, password, isValid } = this.state;
    const {
      className,
      inputProps,
      minLength,
      namespaceClassName,
      scoreWords,
      style,
      tooShortWord,
      userInputs,
    } = this.props;
    const inputClasses = ["ReactPasswordStrength"];
    const WrapperClasses = [
      namespaceClassName,
      className ? className : "",
      password.length > 0 ? `is-strength-${score}` : "",
    ];

    if (isValid === true) {
      inputClasses.push("is-password-valid");
    } else if (password.length > 0) {
      inputClasses.push("is-password-invalid");
    }

    if (inputProps && inputProps.className) {
      inputClasses.push(inputProps.className);
    }

    return (
      <div className={WrapperClasses.join(" ")} style={style}>
        <Input
          type="password"
          {...inputProps}
          value={password}
          className={inputClasses.join(" ")}
          onChange={this.handleOnChange}
        />
        <PasswordStrengthBar
          password={password}
          minLength={minLength}
          scoreWords={scoreWords}
          userInputs={userInputs}
          shortScoreWord={tooShortWord}
          className="ReactPasswordStrength-strength-wrapper"
          scoreWordClassName="ReactPasswordStrength-strength-desc"
        />
      </div>
    );
  }
}
